<ngb-alert [type]="'danger'" [dismissible]="false">
  <strong>Server Error</strong> {{errorMessage}}
</ngb-alert>
